function Footer() {
    return (
            <footer className="py-3 my-4">
                <div className="nav justify-content-center border-top mb-2">
                    <div className="nav-item"><a href="/about" className="nav-link link-body-emphasis">אודות</a></div>
                </div>
                <p className="text-center text-body-secondary">&copy; 2023 המעבדה לאלגוריתמים כלכליים </p>
            </footer>
    )
}
export default Footer;